import { render, staticRenderFns } from "./LoadingNovo.vue?vue&type=template&id=13185d94"
import script from "./LoadingNovo.vue?vue&type=script&lang=js"
export * from "./LoadingNovo.vue?vue&type=script&lang=js"
import style0 from "./LoadingNovo.vue?vue&type=style&index=0&id=13185d94&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports